export default {
  home: "Home",
  whoWeare: "Who are we",
  OurEvents: "Our events",
  Media: "Media",
  ContactUs: "Contact us",
  NothingToDisplay: "Nothing to display",
  OurBlog: "Our Blog",
  AboutUs: "About us",
  DonateNow: "Donate now",
  DownloadReport: "Download report",
  QuickLink: "Quick Link",
  LastEvents: "Lastest Events",
  SeeAllEvent: "See All Events",
  ReadMore: "Read More",
  PageNotFound: "Page not found",
  AboutMessage:
    "Protecting private property encourages businesses to grow. They make profits by meeting the needs of others, and because these profits are retained by the business, rather than confiscated by the authorities, they can be invested creating even more wealth in the future.",
  ParticipacifFinance: "Crowdfunding",
  MeilleurFacon: "The best way to make a difference in the lives of others",
  OtherDomains: "Other areas of intervation",
  RecentPosts: "Recent posts",
  LastEventDesc:
    "Stay up to date with the latest news! Check out our recent events and don't miss any opportunities",
  ExpertBenevole: "Our volunteer experts",
  ExpertBenevoleDesc:
    "Discover our volunteer experts, passionate and committed to making a difference.",
  LastNews: "Our latest news & Articles",
  LastNewsDesc:
    "Check out our latest publications and don't miss any important news.",
  WhatWeDo: "What we do",
  OurTeam: "Our Team",
  OurPartners: "Our partners",
  OurPhotos: "Our photos",
  OurVideos: "Our videos",
  OurMission: "Our mission",
  Domaines: "Areas of intervention",
  Realisations: "Achievements",
  OurVision: "Our vision",
  SearchTitle: "Find Exactly What You’re Looking For",
  SimilarPost: "Similar posts",
  Categories: "Categories",
  MainOffice: "Main Office",
  EmailAddress: "Email Address",
  PhoneNumber: "Phone Number",
  Posts: "Posts",
  "Let Us Help You": "Let Us Help You",
  FooterNews: "Subscribe our newsletter to get our latest update &amp; news",
  OurPartnersDesc:
    "Our partners are key to our mission of fostering collaboration and driving positive change. Together, we work to strengthen our community, share knowledge, and create lasting impact through mutual support and shared values.",
  AboutTitle: "Behind every success story is a story.",

  historique: "History",
  OurActivities: "Our activities",
  OurProjects: "Our projects",
  News: "Our news",
  Reports: "Our reports",
  MeetOurTeam: "One team. One mission. One impact.",
  OurObjectifs: "Our objectives",
  UpComingEvents: "Up coming events",
  ContactSection: "Contact with NSCICO",
  ContactSectionDesc: "Just have a quick <br />any questions?",
  YourName: "Your name",
  YourEmail: "Your email address",
  YourMessage: "Your message",
  Subject: "Subject",
  YourPhone: "Your phone",
  FieldRequired: "This field is required",
  InvalidEmail: "This email address is invalid",
  WhatWeDoTitle: "We Act for<br/>a Better World",
  Welcome: "Welcome to NSCICO",
  WhatWeDoDesc:
    "Through our initiatives, we bring help and hope to <br/> communities in need. Discover how we make a difference <br/>every day.",
} as const;
